export const IMG = {
  fibre: "https://static.prod-images.emergentagent.com/jobs/357a6269-441c-4716-ad7d-1e6c891bd04d/images/58adb733edeb4b83973a1ee7e8bcf182de9d991f0ad2683233d6d23f69f8e7b7.jpeg",
  "5g": "https://static.prod-images.emergentagent.com/jobs/357a6269-441c-4716-ad7d-1e6c891bd04d/images/6049eaf3de8ffedc1d3970e257a057d44d3124f66f181197ba4ded98f736ab0d.jpeg",
  domain: "https://static.prod-images.emergentagent.com/jobs/357a6269-441c-4716-ad7d-1e6c891bd04d/images/5080a1f2bee72e4a7a3335ccf65adacb82eee525bdf2ace5891ae3aadba95228.jpeg",
};

export const TONE = {
  pink: { bg: "bg-[#FFE4EA]", blob: "bg-[#F0326E]/15", blob2: "bg-[#FFC23D]/30" },
  sky: { bg: "bg-[#E4F2FC]", blob: "bg-[#0FB5A5]/15", blob2: "bg-[#F0326E]/10" },
  mint: { bg: "bg-[#DDF7EE]", blob: "bg-[#0FB5A5]/20", blob2: "bg-[#FFC23D]/30" },
};

export const PageHero = ({ eyebrow, title, sub, img, tone = "pink", children, testid }) => {
  const t = TONE[tone];
  return (
    <section className={`relative overflow-hidden ${t.bg}`} data-testid={testid}>
      <div className={`blob absolute -left-24 -top-24 h-80 w-80 ${t.blob}`} />
      <div className={`blob absolute -bottom-32 right-1/3 h-72 w-72 ${t.blob2}`} style={{ animationDelay: "-5s" }} />
      <div className="relative mx-auto grid max-w-7xl items-center gap-8 px-4 py-12 sm:px-6 md:grid-cols-12 lg:px-8 lg:py-16">
        <div className="fade-up md:col-span-7">
          <p className="inline-flex rounded-full bg-white/80 px-3 py-1 text-xs font-bold uppercase tracking-[0.15em] text-primary shadow-sm">{eyebrow}</p>
          <h1 className="mt-4 text-4xl font-extrabold leading-[1.05] sm:text-5xl lg:text-6xl">{title}</h1>
          {sub && <p className="mt-4 max-w-xl text-base text-foreground/70 sm:text-lg">{sub}</p>}
          {children && <div className="mt-8">{children}</div>}
        </div>
        {img && (
          <div className="hidden md:col-span-5 md:block">
            <img src={img} alt="" className="float-y mx-auto w-full max-w-sm rounded-[2rem] object-cover mix-blend-multiply" />
          </div>
        )}
      </div>
    </section>
  );
};
